import { render, staticRenderFns } from "./rcs-tab.vue?vue&type=template&id=9942bb34&scoped=true"
import script from "./rcs-tab.vue?vue&type=script&lang=js"
export * from "./rcs-tab.vue?vue&type=script&lang=js"
import style0 from "./rcs-tab.vue?vue&type=style&index=0&id=9942bb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9942bb34",
  null
  
)

export default component.exports